var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'import-error-card':_vm.errorList.length>0}},_vm._l((_vm.errorList),function(item,index){return _c('el-alert',{key:index,staticStyle:{"margin":"0 6px 6px 0","width":"fit-content","padding-right":"30px"},attrs:{"closable":"","title":`${item.rowNum}行${item.errorMsg}`,"type":"error","effect":"dark"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }